import { createAction, props } from '@ngrx/store';
import {
  FonctionTypesOptionsLoadedPayload,
} from './custom.payloads';

export const fonctionTypesOptionsLoaded = createAction(
  '[Custom] FonctionTypes options loaded',
  props<FonctionTypesOptionsLoadedPayload>()
);
